import { Component, ErrorHandler, EventEmitter, Inject, Input, Output, DOCUMENT, ChangeDetectionStrategy } from '@angular/core'
import { AineistonLatausVirhe } from '@lemon/core-firebase/model/kirjanpidon-aineisto'
import { isEnumValue } from '@lemon/core/typescript'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonaid.service'
import { KayttajaService } from 'app/_angular/service/kayttaja.service'
import { TunnistautuminenService } from 'app/_angular/service/tunnistautuminen.service'
import { LadataanService } from 'app/_jaettu-angular/service/ladataan.service'

import { AloitaTunnistautuminenAineistonLatausJaAnnaUrlRequest, AloitaTunnistautuminenJaAnnaUrlResponse, InGroupeAuthMethod } from '@lemon/core-firebase/model/tunnistaminen'
import { environment } from 'environments/environment'
import { TunnistautuminenNetsPankitComponent } from './pankit.component'

export interface AineistonLatausTunnistautuminenData {
  token: string
}

@Component({
  standalone: false,
  selector: '[tunnistautuminen-nets-aineiston-lataus-pankit]',
  templateUrl: './pankit.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pankit.component.css'],
})
export class TunnistautuminenNetsAineistonLatausComponent extends TunnistautuminenNetsPankitComponent {
  @Input() data: AineistonLatausTunnistautuminenData
  @Output() tunnistauduError: EventEmitter<AineistonLatausVirhe> = new EventEmitter<AineistonLatausVirhe>()

  constructor(
    @Inject(DOCUMENT) private __document: Document,
    private __kirjautunutKayttajaService: KayttajaService,
    private __ladataanService: LadataanService,
    private __errorHandler: ErrorHandler,
    private __tunnistautuminenService: TunnistautuminenService,
    protected __firebaseLemonaid: FirebaseLemonaid,
  ) {
    super(__document, __kirjautunutKayttajaService, __ladataanService, __errorHandler, __tunnistautuminenService, __firebaseLemonaid)
  }

  protected override async _aloitaTunnistautuminenJaAnnaUrl(authMethod: InGroupeAuthMethod): Promise<AloitaTunnistautuminenJaAnnaUrlResponse> {
    const request: AloitaTunnistautuminenAineistonLatausJaAnnaUrlRequest = {
      action: this.actionAfterSuccess,
      authMethod,
      kieli: this.kieli || 'fi',
      env: this._tunnistautuminenService.getNetsEnvironment(environment.environment),
      token: this.data.token,
    }
    const response = await this._firebaseLemonaid.functionsCall<AloitaTunnistautuminenAineistonLatausJaAnnaUrlRequest, AloitaTunnistautuminenJaAnnaUrlResponse | AineistonLatausVirhe>(
      'tunnistautuminenNetsAloitaAineistonLatausJaAnnaUrl',
      request,
    )
    if (isEnumValue(AineistonLatausVirhe, response)) {
      this.tunnistauduError.emit(response)
      return null
    }
    return response
  }
}
